import { BaseDriver } from './device'
import { ResDeviceState } from '../../libs/types/response'
import { na87Data } from './data_conversion/na87'
import { DeviceProtocol } from '../../hid/device/device_model'
import { Magnet } from './magnet'
import { OutputMode, VirtualMg75Pro } from '../../hid/define/define'
import { defaultVK } from '../../hid/define/define_keys'
import { lightMatrix } from '../../hid/define/define_light_matrix'
import { KK } from '../../hid/define/define'
import { deviceManager } from '../../hid/device/device_manager'
import { bytesPadding64, delay, makeData64WithCRC, printHex } from '@libs/utils/tools'
import { GetDevicesEnbleKeys, allKeysForDevice } from '@hid/define/define_fn'
import { DeviceConnectMode, MusicCaptureStatus, SpecificItem } from '@libs/types/enum'
import firmware from '@/upgrade/firmware'
import { musicData } from '@libs/music/music'

enum NA87MU68ProCMDType {
  SetLeds = 0x18,
  SetCustomColor = 0x2a,
}
export class na87Driver extends BaseDriver {
  updateFirmware(): Promise<boolean> {
    throw new Error('Method not implemented.')
  }
  declare magnet: Magnet | undefined
  musicIns: musicData
  constructor(public DeviceHID: DeviceProtocol) {
    super(DeviceHID)
    this.magnet = new Magnet(this.DeviceHID, this)
    this.musicIns = new musicData(this.onMusicData)
  }

  async pair24g() {
    return 0
  }
  async syncDecorationLed() {}

  makeCMDSelectArg(keys: KK[], select: number, secound?: number): Map<KK, number[]> {
    const res = new Map<KK, number[]>()
    keys.forEach((k) => {
      res.set(k, [select, secound == undefined ? 0xff : secound, 0xff])
    })
    return res
  }

  makeSimple(data: number[]): Map<KK, number[]> {
    const res = new Map<KK, number[]>([[data[0] as KK, data.slice(1)]])
    return res
  }

  // TODO:解决，MG75PRO，V1.0.8的固件，在cmd发送消息后，不返回结果的问题
  private async cmdKeyNoWait(cmd: number, sets: Map<KK, number[]>, write = false) {
    let prefixed = [0x5c, 0, cmd, 0, write ? 1 : 0]
    let index = 0
    const data: number[][] = [[...prefixed]]
    sets.forEach((v, k) => {
      if (data[index].length >= 64 - v.length) {
        index++
        data[index] = [...prefixed]
      }
      data[index].push(k, ...v)
    })
    for (let i = 0; i < data.length; i++) {
      data[i][1] = data[i].length - 4
      data[i] = makeData64WithCRC(data[i])
      const toSend = bytesPadding64(data[i], 64, [0xff])
      await this.DeviceHID.send(toSend, false, false)
    }
  }

  async cmdKey(cmd: number, sets: Map<KK, number[]>, write = false): Promise<Map<KK, [number, number]>> {
    if (sets.size == 0) return new Map<KK, [number, number]>()
    let index = 0
    let prefixed = [0x5c, 0, cmd, 0, write ? 1 : 0]
    // if (otherHead) prefixed = otherHead
    const data: number[][] = [[...prefixed]]
    sets.forEach((v, k) => {
      if (data[index].length >= 64 - v.length) {
        index++
        data[index] = [...prefixed]
      }
      data[index].push(k, ...v)
    })
    const resp = new Map<KK, [number, number]>()
    for (let i = 0; i < data.length; i++) {
      data[i][1] = data[i].length - 4
      const toSend = makeData64WithCRC(data[i])
      const r = await this.DeviceHID.send(toSend)
      if (r[4] != 0x00) {
        printHex(r, 'receive:')
        printHex(toSend, 'send:')
        throw new Error('getKeysTravel error')
      }
      if (!write) {
        const fwVersionIs107 = await firmware.versionIs20241125a()
        if (fwVersionIs107 && cmd == 0x2c) {
          for (let j = 5; j < r.length; j += 6) {
            if (j > r.length - 5) {
              break
            }
            if (r[j] == 0 || r[j] == 0xff) {
              continue
            }
            resp.set(r[j] as KK, [r[j + 1], 0])
            if (r[j + 3] != 0 && r[j + 3] != 0xff) {
              resp.set(r[j + 3] as KK, [r[j + 4], 0])
            }
          }
        } else {
          for (let j = 5; j < r.length; j += 4) {
            if (j > r.length - 3) {
              break
            }
            if (r[j] == 0 || r[j] == 0xff) continue
            if (cmd == 0x2c) {
              resp.set(r[j] as KK, [r[j + 1], 0])
              if (r[j + 2] != 0 && r[j + 2] != 0xff) {
                resp.set(r[j + 2] as KK, [r[j + 3], 0])
              }
            } else {
              resp.set(r[j] as KK, [r[j + 2], r[j + 3]])
            }
          }
        }
      }
    }
    return resp
  }

  pauseMusicCapture = async () => {
    await this.musicIns.musicCapturePause()
  }
  continueMusicCapture = async () => {
    await this.musicIns.musicCaptureContinue()
  }
  async syncKeys() {
    await this.pauseMusicCapture()
    const keys = this.save.Keys

    const change = new Map<KK, number[]>()
    const changeFn = new Map<KK, number[]>()

    const changeOfReset = new Map<KK, number[]>() //重置普通层
    const changeOfResetFn = new Map<KK, number[]>() //重置Fn层
    const changeOfResetSenior = new Map<KK, number[]>() //重置高级改键层

    if (this.changeProfileFlag) {
      GetDevicesEnbleKeys(deviceManager.deviceID).forEach((_, kk) => {
        changeOfReset.set(kk, [0, kk, 0])
        changeOfResetSenior.set(kk, [8, 0, 0])
        this.setFnKeyData(changeOfResetFn, kk, true)
      })
    }

    const kks = keys.map((item) => item.Input.KK)
    const dataKey = await this.cmdKey(0x23, this.makeCMDSelectArg(kks, 0x08))

    //同步普通改键
    keys.forEach((item) => {
      // 处理dataKey.get(item.Input.KK) 找不到的情况
      if (dataKey.get(item.Input.KK) == undefined) {
        return // forEach中return不会终止循环
      }

      if (item.Output.Mode == OutputMode.Key && item.Output.VK == defaultVK) {
        const travel = dataKey.get(item.Input.KK)![0] & 0b11110000
        changeOfResetSenior.set(item.Input.KK, [8, travel, 0])
        if (item.Input.WithFN) {
          this.setFnKeyData(changeOfResetFn, item.Input.KK, false)
        } else {
          changeOfReset.set(item.Input.KK, [0, item.Input.KK, 0])
        }
      } else if (item.Output.Mode == OutputMode.Key) {
        const travel = dataKey.get(item.Input.KK)![0] & 0b11110000
        changeOfResetSenior.set(item.Input.KK, [8, travel, 0])

        const keyData = na87Data.encodeKey(item)
        if (item.Input.WithFN) {
          changeFn.set(item.Input.KK, [keyData[1], keyData[2], keyData[3]])
        } else {
          change.set(item.Input.KK, [keyData[1], keyData[2], keyData[3]])
        }
      }
    })

    if (changeOfResetSenior.size > 0) await this.cmdKey(0x23, changeOfResetSenior, true)
    if (changeOfReset.size > 0) await this.cmdKey(0x23, changeOfReset, true)
    if (changeOfResetFn.size > 0) await this.cmdKey(0x23, changeOfResetFn, true)
    if (change.size > 0) await this.cmdKey(0x23, change, true)
    if (changeFn.size > 0) await this.cmdKey(0x23, changeFn, true)

    this.clearResetKeys()
    await this.magnet?.clearKmeBind()
    await this.continueMusicCapture()
  }

  setFnKeyData(changeOfResetFn: Map<KK, number[]>, key: KK, isReset: boolean) {
    let setValue = isReset ? 0x01 : key
    let fnKey = na87Data.getFnDisableKeysData(deviceManager.deviceID).get(key)
    if (fnKey != undefined) {
      changeOfResetFn.set(key, [1, fnKey[0], fnKey[1]])
    } else {
      changeOfResetFn.set(key, [1, setValue, 0])
    }
  }

  async getVersion() {
    const data = makeData64WithCRC([0x5c, 0x02, 0x01, 0x00, 0xff, 0xff])
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('getVersion error')
    }
    const version = res.slice(30, 44)
    let str = version.map((v) => String.fromCharCode(v)).join('')
    const fd = str.match(/V(\d+\.?)+/g)
    if (fd) {
      str = fd[0].replace('V', '')
    }
    if (str.match(/^(\d\.{0,1})+/g) == null) {
      throw new Error('getVersion error')
    }
    return str
  }

  async getDeviceState(): Promise<ResDeviceState> {
    const res: ResDeviceState = {
      ConnectType: DeviceConnectMode.Normal,
      IsConnect: true,
      IsSleep: false,
    }
    return res
  }

  private async getLockWin(): Promise<boolean> {
    const data = Array(64).fill(0)
    data[0] = 0x5c
    data[1] = 0x03
    data[2] = 0x00
    data[3] = 0x93
    data[4] = 0x20
    data[5] = 0xff
    data[6] = 0xff
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('getLockWin error' + res[4])
    }
    return Boolean(res[6])
  }

  async syncLeds() {
    await this.pauseMusicCapture()
    const lightMode = this.save.LightMode
    const data = Array(64).fill(0)
    data[0] = 0x5c
    data[1] = 0x2c
    data[2] = NA87MU68ProCMDType.SetLeds
    data[3] = 0xd4
    data[4] = 0x01
    data[42] = lightMode.Light
    data[43] = lightMode.Mode
    data[44] = lightMode.Speed
    data[45] = 0x00 // SLEEP[1B] 休眠时间，默认 0x00 为永久
    data[46] = 0xff
    data[47] = 0xff

    const fwVersionIs104 = await firmware.fwVersionLessThan('1.0.4', firmware.fwVersionDvs1)
    if (fwVersionIs104) {
      // 指定设备的版本小于 1.0.4 时，不修改 data[9] 到 data[46]
    } else {
      const { r, g, b } = this.numberToRgb(lightMode.Color)
      data[9] = b
      data[10] = g
      data[11] = r
      data[12] = 0xff
      data[13] = 255
      data[14] = 102
      data[15] = 51
      data[16] = 0xff
      data[7] = 255
      data[18] = 51
      data[19] = 102
      data[20] = 0xff
      data[21] = 0
      data[22] = 0
      data[23] = 255
      data[24] = 0xff
      data[25] = 61
      data[26] = 0
      data[27] = 245
      data[28] = 0xff
      data[29] = 102
      data[30] = 255
      data[31] = 51
      data[32] = 0xff
      data[33] = 138
      data[34] = 0
      data[35] = 184
      data[36] = 0xff
      data[46] = 0x00
    }
    const readData = await this.readbitmap()
    data[41] = readData[41] | 1 //打开灯效
    if (lightMode.Direction == 0) {
      data[41] = data[41] & 0b11111101
    } else {
      data[41] = data[41] | 0b0010
    }
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('syncLeds error' + res[4])
    }
    await this.continueMusicCapture()
  }

  private async turnOnColorCustom() {
    await this.pauseMusicCapture()
    const lightMode = this.save.LightMode
    const data = Array(64).fill(0)
    data[0] = 0x5c
    data[1] = 0x2c
    data[2] = NA87MU68ProCMDType.SetLeds
    data[3] = 0xd4
    data[4] = 0x01
    data[42] = lightMode.Light
    data[43] = 0x15
    data[44] = 0x03

    data[45] = 0x00 // SLEEP[1B] 休眠时间，默认 0x00 为永久
    data[46] = 0xff
    data[47] = 0xff
    const fwVersionIs104 = await firmware.fwVersionLessThan('1.0.4', firmware.fwVersionDvs1)
    if (fwVersionIs104) {
      data[43] = 0x0e
    }
    const readData = await this.readbitmap()
    data[41] = readData[41] | 1 //打开灯效
    if (lightMode.Direction == 0) {
      data[41] = data[41] & 0b11111101
    } else {
      data[41] = data[41] | 0b0010
    }
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('syncLeds error' + res[4])
    }
    await this.continueMusicCapture()
  }

  private numberToRgb(num: number): { r: number; g: number; b: number } {
    const r = (num >> 16) & 0xff
    const g = (num >> 8) & 0xff
    const b = num & 0xff
    return { r, g, b }
  }

  async setCustomColorOneKey(key: KK, color: number) {
    const { r, g, b } = this.numberToRgb(color)
    const data = new Map<KK, number[]>([[key, [r, g, b]]])
    await this.cmdKey(0x2a, data, true)
  }

  async syncCustomColor() {
    await this.pauseMusicCapture()
    //TODO 如果已经是自定义颜色，不需要再次发送
    if (this.save.LightLastIsCustom) {
      await this.turnOnColorCustom()
      await delay(500) //不加延迟, 可能会导致ESC键自定义灯效失败
    }
    const data = new Map<KK, number[]>()
    const keys = allKeysForDevice(deviceManager.deviceID)
    keys.forEach(async (key) => {
      data.set(key, [0, 0, 0])
    })
    this.save.ColorsCustom.forEach((value, key) => {
      const { r, g, b } = this.numberToRgb(value)
      data.set(key, [r, g, b])
    })

    const MG75ProOfwVersionGT108 = await firmware.fwVersionGreaterThanOrEqual('1.0.8', [VirtualMg75Pro])

    if (MG75ProOfwVersionGT108) {
      await this.sendCustomColorForV108(data)
    } else {
      await this.cmdKey(0x2a, data, true)
    }
    await this.saveCustomColorBoard(!MG75ProOfwVersionGT108)
    await this.continueMusicCapture()
  }

  private async sendCustomColorForV108(data: Map<KK, number[]>) {
    await this.cmdKeyNoWait(0x2a, data, true)
  }

  // 保存自定义颜色到键盘内存
  private async saveCustomColorBoard(isWait = true) {
    const sets = new Map<KK, number[]>([[0xfe as KK, [0xfe, 0xfe, 0xfe]]])
    if (isWait) {
      await this.cmdKey(0x2a, sets, true)
    } else {
      await this.cmdKeyNoWait(0x2a, sets, true)
    }
  }

  async syncDynamicColor(): Promise<boolean> {
    const colorsDynamic = this.save.ColorsDynamic
    if (this.changeProfileFlag && colorsDynamic.Run == false) {
      return true
    }

    let state = MusicCaptureStatus.Stop
    if (colorsDynamic.Run) {
      if (!this.save.LightLastIsCustom) {
        await this.turnOnColorCustom()
      }
      state = MusicCaptureStatus.Start
    }
    return await this.setDynamicColorState(state)
  }

  private async setDynamicColorState(state: MusicCaptureStatus) {
    this.musicIns.setColorsDynamic(this.save.ColorsDynamic)
    return await this.musicIns.dynamicColorState(state)
  }

  private onMusicData = async (data: number[]) => {
    if (this.save.ColorsDynamic.Run == false) {
      return
    }
    if (data.length > 0) {
      this.sendEffectData(data)
    }
  }

  private async sendEffectData(data: number[]) {
    let keyMap = lightMatrix(deviceManager.deviceID)
    let sendKeys = new Map<KK, number[]>()
    for (let i = 0; i < keyMap.size; i++) {
      let k = keyMap.get(i)
      if (k == undefined || k == 0) {
        continue
      }
      sendKeys.set(k as KK, [data[i * 3], data[i * 3 + 1], data[i * 3 + 2]])
    }
    const MG75PROfwVersionGT108 = await firmware.fwVersionGreaterThanOrEqual('1.0.8', [VirtualMg75Pro])
    if (MG75PROfwVersionGT108) {
      await this.sendCustomColorForV108(sendKeys)
    } else {
      await this.cmdKey(0x2a, sendKeys, true)
    }
  }

  async syncConfig() {
    const isVersion20241125a = await firmware.versionIs20241125a()
    const isVersion20250326 = await firmware.versionIs20250326()
    if (isVersion20241125a || isVersion20250326) {
      await this.magnet?.syncKeysDeadZone()
      return
    }
    let deadZone = this.save.DeadZone1
    if (deadZone == undefined) {
      deadZone = [200, this.save.DeadZone]
    }
    await this.magnet?.readOrSetDeadZone(true, deadZone)
  }

  async setOrReadSpecificItem(item: string, isWrite: boolean, value: any) {
    const item2 = item as SpecificItem

    if (item2 == SpecificItem.SuperResponsiveMode) {
      if (typeof value != 'boolean') throw new Error('value must be boolean')
      return await this.setSuperResponsiveMode(value, isWrite)
    }

    if (item2 == SpecificItem.LockWin) {
      if (isWrite) throw new Error('LockWin is read only')
      return await this.getLockWin()
    }
    if (item2 == SpecificItem.DeadZone) {
      return await this.magnet?.readOrSetDeadZone(isWrite, value)
    }

    if (item2 == SpecificItem.Rate) {
      return await this.setOrReadRate(isWrite, value)
    }

    return null
  }

  async setOrReadRate(isWrite: boolean, value: number) {
    const RateList = [8000, 4000, 2000, 1000, 500, 250, 125]

    const data = Array(64).fill(0)
    data[0] = 0x5c
    data[1] = 0x03
    data[2] = 0x00
    data[4] = 0x50
    if (isWrite) {
      const valueIndex = RateList.findIndex((v) => v == value)
      if (valueIndex == -1) {
        throw new Error('Rate not found:' + value)
      }
      data[1] = 0x04
      data[5] = valueIndex
      data[6] = 0xff
      data[7] = 0xff
    } else {
      data[5] = 0xff
      data[6] = 0xff
    }

    data[3] = (0x35 + data[0] + data[1] + data[2] + 0xff) & 0xff
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('setRate failed')
    }

    const index = res[6]
    if (RateList[index] == undefined) {
      throw new Error('Rate not found:' + index)
    }
    return RateList[index]
  }

  private async readbitmap(): Promise<number[]> {
    const data = Array(64).fill(0)
    data[0] = 0x5c
    data[1] = 0x2c
    data[2] = 0x18
    data[3] = (0x35 + data[0] + data[1] + data[2] + 0x00) & 0xff
    const res = await this.DeviceHID.send(data)
    if (res[4] != 0x00) {
      throw new Error('readbitmap failed')
    }
    return res
  }

  private async setSuperResponsiveMode(value: boolean, isWrite: boolean) {
    const readData = await this.readbitmap()
    if (!isWrite) {
      return (readData[41] & 0b10000) > 0
    }
    readData[1] = 0x2c
    readData[2] = 0x18
    readData[4] = 1
    readData[41] = value ? readData[41] | 0b10000 : readData[41] & 0b11101111
    readData[3] = (0x35 + readData[0] + readData[1] + readData[2] + 0xff) & 0xff

    const resData = await this.DeviceHID.send(readData)
    if (resData[4] != 0x00) {
      throw new Error('handleSuperResponsiveMode failed')
    }
    return (readData[41] & 0b00010000) > 0
  }

  async syncMacros() {
    await this.pauseMusicCapture()
    const keys = this.save.Keys
    const macros = this.save.Macros

    let onceGroupLen = 14
    let keyDataLen = 4
    const isDoc107 = await firmware.versionIs20250326()
    if (isDoc107) {
      onceGroupLen = 9
      keyDataLen = 6
    }

    for (const item of keys) {
      if (item.Output.Mode == OutputMode.Macro) {
        const macro = macros.get(item.Output.DataIndex)
        if (macro && macro.length > 0) {
          const params: number[] = []
          macro.forEach((r) => {
            params.push(...na87Data.genarateMacroData(r, keyDataLen))
          })

          const groupLen = Math.ceil(params.length / keyDataLen / onceGroupLen)
          for (let index = 0; index < groupLen; index++) {
            const len = index == groupLen - 1 ? (params.length / keyDataLen) % onceGroupLen : onceGroupLen
            const data = Array(64).fill(0)
            data[0] = 0x5c
            data[1] = len * keyDataLen + 4
            data[2] = 0x20
            data[4] = 0x01

            data[5] = index * onceGroupLen
            data[6] = isDoc107 ? 0x01 : 0x00

            data[7] = len == 0 ? onceGroupLen : len

            for (let k = 8; k < keyDataLen * onceGroupLen + 8; k++) {
              if (params[index * keyDataLen * onceGroupLen + k - 8]) {
                data[k] = params[index * keyDataLen * onceGroupLen + k - 8]
              }
            }

            data[3] = (0x35 + data[0] + data[1] + data[2] + data[len * keyDataLen + 7]) & 0xff
            const resData = await this.DeviceHID.send(data)
            if (resData[4] != 0x00) {
              throw new Error('sync macro error')
            }
          }

          const macroKeyData = na87Data.macroData(item)

          const sets: Map<KK, number[]> = new Map()
          sets.set(item.Input.KK, macroKeyData)
          await this.cmdKey(0x23, sets, true)

          if (isDoc107) {
            const macroConfig = na87Data.macroDataConfig(item)
            const sets1: Map<KK, number[]> = new Map()
            sets1.set(item.Input.KK, macroConfig)
            await this.cmdKey(0x21, sets1, true)
          }
        }
      }
    }
    this.magnet?.clearKmeBind()
    await this.continueMusicCapture()
  }

  async reset() {
    const resetData = [0x5c, 0x03, 0x00, 0x93, 0x11, 0xff, 0xff]
    const res = await this.DeviceHID.send(resetData)
    if (res[4] != 0x00) {
      throw new Error('reset error')
    }
  }
}
